import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default from 'react';
import classNames from 'classnames';
import buttonStyles from './Button.js';
import { useInputGroupContext } from '../InputGroup/InputGroupProvider.js';

const Button = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    children,
    kind = 'default',
    disabled = false,
    small = false,
    full = false,
    className = '',
    type = 'button',
    onClick,
    onKeyDown,
    'aria-disabled': ariaDisabled,
    ...rest
  } = _ref;
  const inputGroupContext = useInputGroupContext();
  const classes = classNames(className, buttonStyles.btn, inputGroupContext.className, {
    [buttonStyles[kind]]: kind,
    [buttonStyles.disabled]: disabled,
    [buttonStyles.small]: inputGroupContext.applySmall(small),
    [buttonStyles.full]: inputGroupContext.applyFull(full)
  });
  const clickHandler = e => {
    if (disabled) {
      // stops form submission for type="submit"
      return e.preventDefault();
    }
    onClick === null || onClick === void 0 || onClick(e);
  };
  const keyDownHandler = disabled ? undefined : onKeyDown;
  return /*#__PURE__*/ /* eslint-disable react/button-has-type */React__default.createElement("button", _extends({}, rest, {
    "aria-disabled": ariaDisabled !== null && ariaDisabled !== void 0 ? ariaDisabled : disabled,
    type: type,
    className: classes,
    ref: ref,
    onClick: clickHandler,
    onKeyDown: keyDownHandler
  }), children)
  /* eslint-disable react/button-has-type */;
});

export { Button };
